var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-header"},[(_vm.isZealandFlow)?_c('h5',[_vm._v("Excelerate - gratis for alle studerende")]):_c('h5',[_vm._v("Excelerate - free to use for students")])])
}
var staticRenderFns = []

export { render, staticRenderFns }